import { render, staticRenderFns } from "./AddOrUpdateScopeIdentifier.vue?vue&type=template&id=07d668fe&scoped=true"
import script from "./AddOrUpdateScopeIdentifier.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateScopeIdentifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d668fe",
  null
  
)

export default component.exports